import AllGame from "../Screens/AllGame";
import Aviator from "../Screens/Aviator/Aviator";
import Chart from "../Screens/Chart/Chart";
import ResultData from "../Screens/Chart/ResultData";
import Disclaimer from "../Screens/Disclaimer";
import Home from "../Screens/Home/Home";
import LiveGames from "../Screens/Home/LiveGame";
import LeaderBoard from "../Screens/LeaderBoard";
import Match from "../Screens/Match";
import Mines from "../Screens/Mines/Mines";
import PlinkoWithPhysics from "../Screens/Plinko/Plinko";
import Profile from "../Screens/Profile";
import Share from "../Screens/Share/Share";
import Support from "../Screens/Support/Support";
import Wallet from "../Screens/Wallet";
import ShowWallet_fundHistory from "../Screens/Wallet/ShowWallet_FundHistory";
import Transactions from "../Screens/Wallet/Transactions";
import ProtectedAuth from "./PrivateAuth";

export const PrivateRoutes = () => {
  return [
    {
      element: <ProtectedAuth />,
      children: [
        {
          path: "/allGame",
          element: <AllGame />,
          useLayout: true,
        },
        {
          path: "/home",
          element: <Home />,
          useLayout: true,
        },
        {
          path: "/profile",
          element: <Profile />,
          useLayout: true,
        },
        {
          path: "/disclaimer",
          element: <Disclaimer />,
          useLayout: true,
        },
        {
          path: "/chart",
          element: <Chart />,
          useLayout: true,
        },
        {
          path: "/chart/result_data",
          element: <ResultData />,
          useLayout: true,
        },
        {
          path: "/match",
          element: <Match />,
          useLayout: true,
        },
        {
          path: "/leaderboard",
          element: <LeaderBoard />,
          useLayout: true,
        },
        {
          path: "/support",
          element: <Support />,
          useLayout: true,
        },
        {
          path: "/share",
          element: <Share />,
          useLayout: true,
        },

        {
          path: "/transaction_history",
          element: <Transactions />,
          useLayout: true,
        },
        {
          path: "/wallet/show_Wallet_fund_History",
          element: <ShowWallet_fundHistory />,
          useLayout: true,
        },
        {
          path: "/wallet",
          element: <Wallet />,
          useLayout: true,
        },
        {
          path: "/game/live_game",
          element: <LiveGames />,
          useLayout: true,
        },
        {
          path: "/lottery/aviator",
          element: <Aviator />,
          useLayout: false,
        },
        {
          path: "/mini-games/mines",
          element: <Mines />,
          useLayout: false,
        },
        {
          path: "/mini-games/plinko",
          element: <PlinkoWithPhysics />,
          useLayout: false,

        },
        // ERROR ROUTES ENDED
      ],
    },
  ];
};
